/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ActionFilters } from '../models/ActionFilters';
import { OperationIdFilters } from '../models/OperationIdFilters';
import { StatusCodeFilters } from '../models/StatusCodeFilters';
import { UserIdFilters } from '../models/UserIdFilters';

export class AuditLogFilterConditions {
  'action'?: ActionFilters;
  'operationName'?: OperationIdFilters;
  'initiatorId'?: UserIdFilters;
  'statusCode'?: StatusCodeFilters;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "action",
      "baseName": "action",
      "type": "ActionFilters",
      "format": ""
    },
    {
      "name": "operationName",
      "baseName": "operationName",
      "type": "OperationIdFilters",
      "format": ""
    },
    {
      "name": "initiatorId",
      "baseName": "initiatorId",
      "type": "UserIdFilters",
      "format": ""
    },
    {
      "name": "statusCode",
      "baseName": "statusCode",
      "type": "StatusCodeFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AuditLogFilterConditions.attributeTypeMap;
  }

  public constructor() {
  }
}

